export default "__VITE_ASSET__NOVD29JD__"